import React, { useState } from 'react';
import AvatarFormsPanel from '../avatarAncV2/AvatarFormsPanel';
import InstallationCardActions, { InstallationCardForms } from '../avatarAncV2/InstallationCardActions';
import CardItem from '../UI/DataGridCard/CardItem';

/** A line of /#/p/ancs: the avatar card, with the same access to the history and the forms as the v2 board. */
const AvatarCard = ({ record }: { record: any }) => {
    const [formsOpen, setFormsOpen] = useState(false);

    return (
        <CardItem
            record={record}
            headerAction={
                <InstallationCardActions
                    record={record}
                    formsOpen={formsOpen}
                    onToggleForms={() => setFormsOpen(!formsOpen)}
                />
            }
        >
            <InstallationCardForms open={formsOpen}>
                <AvatarFormsPanel avatarId={record.id} serialNumber={record.alphaId} />
            </InstallationCardForms>
        </CardItem>
    );
};

export default AvatarCard;
